import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listUsers:[],
  newUser:[]
};
export const mutations = {
  GET_USERS({ context }, users) {
    let users_array = [];
    let userStorage = JSON.parse(localStorage.getItem("user"));
    Object.entries(users).forEach(([key, val]) => {
      if(userStorage.roles[0].name == 'admin'){
        // if(val.roles[0].name == 'enlace'){
        //   users_array.push(val)
        // }
      }
      if(userStorage.roles[0].name == 'superadmin'){
        users_array.push(val)
      }
    });
    return (state.listUsers = users_array);
  },

  SAVE_USERS({ context }, user) {
    state.newUser = Object.assign({}, user);
  },
  EDIT_USER({ context }, dataUser) {
    state.dataUser = Object.assign({}, dataUser);
  },
};
export const actions = {
  GET_USERS({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_USERS", response.data.data.users);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  SAVE_USERS({ commit }, user) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(user)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("SAVE_USERS", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  EDIT_USER({ commit }, dataUser) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.put(dataUser)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("EDIT_USER", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  DELETE_USER({ commit }, id) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.delete(id)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_FOLIO({ commit }, id) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(id)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  }
};

export const getters = {//leer datos
  listUsers: (state) => state.listUsers,
  newUser: state => state.newUser
};
